var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxboldformatSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8,7.5c1.2-0.5,2-1.7,2-3c0-1.8-1.5-3.2-3.2-3.2c-1.3,0-2.5,0.8-3,2h-9c-0.5-1.2-1.7-2-3-2 c-1.8,0-3.2,1.5-3.2,3.2c0,1.3,0.8,2.5,2,3v9c-1.2,0.5-2,1.7-2,3c0,1.8,1.5,3.2,3.2,3.2c1.3,0,2.5-0.8,3-2h9c0.5,1.2,1.7,2,3,2 c1.8,0,3.2-1.5,3.2-3.2c0-1.3-0.8-2.5-2-3V7.5z M7.7,4.8h8.7c0.3,2.7,2.9,2.9,2.9,2.9v8.6c-2.7,0.2-2.9,3-2.9,3H7.7 c0,0,0-2.7-2.9-3V7.5C4.8,7.5,7.4,7.6,7.7,4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2,15.8c-0.3-0.3-0.3-0.8,0-1.1L9,13.9 c-0.4-0.6-0.6-1.3-0.6-2.1c0-2.1,1.7-3.8,3.8-3.8S16,9.7,16,11.8s-1.7,3.8-3.8,3.8c-0.8,0-1.5-0.2-2.1-0.6l-0.8,0.8 C8.8,16.3,8.2,15.8,8.2,15.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxboldformatSearch);
export default __webpack_public_path__ + "static/media/vuesaxboldformat-search.972abf30c9b0176ab48888cfe969f0ec.svg";
export { ForwardRef as ReactComponent };